const translations = {
  en: {
    appTitle: "Refugee Resources",
    welcome: "Welcome! Tell us about yourself.",
    welcomeForm: "Welcome",
    firstName: "First Name",
    lastName: "Last Name",
    roleLabel: "I am a...",
    refugee: "Refugee",
    volunteer: "Volunteer",
    parent: "Parent",
    guardian: "Guardian",
    phone: "Phone Number",
    housing: "Where do you live?",
    street: "Street Address",
    city: "City",
    zip: "Zip Code",
    dwelling: "Dwelling Type",
    house: "House",
    apartment: "Apartment",
    aptName: "Apartment Name",
    aptNumber: "Apartment Number",
    journey: "Tell us about your journey",
    volunteerInfo: "Tell us where you serve.",
    origin: "Country of Origin",
    arrival: "Date of Arrival",
    office: "Office Location (for volunteers)",
    team: "Team (for volunteers)",
    languagePref: "Language Preferences",
    preferredLang: "Preferred Language",
    acknowledgment: "By proceeding, you acknowledge that all information provided is accurate to the best of your knowledge and may be used to provide appropriate services.",
    acknowledgeLabel: "I acknowledge",
    back: "Back",
    next: "Next",
    complete: "Complete",
    saving: "Saving...",
    cancel: "Cancel",
    signOut: "Sign Out",
    footerText: "Transforming Lives, One Child at a Time",
    personalInfo: "Personal Information",
    housingInfo: "Housing Information",
    background: "Background",
    selectLanguage: "Select Your Language",
    chooseLanguage: "Please select your preferred language:",
    language: "Language",
    editProfile: "Edit Your Profile",
    completeProfile: "Complete Your Profile",
    personalInfoStep: "Personal Information",
    housingInfoStep: "Housing Information",
    backgroundStep: "Background",
    languageStep: "Language",
    selectFormPrompt: "Please select a form to get started:",
    readingCircleEnrollment: "Reading Circle Enrollment",
    preschoolCircleEnrollment: "Preschool Circle Enrollment",
    readingCircleDescription: "Enroll children in our reading program designed to build literacy skills and foster a love for reading.",
    preschoolCircleDescription: "Enroll children in our early education program focused on preparing young learners for successful academic journeys.",
    beginForm: "Begin Form",
    moreFormsComing: "More Forms Coming Soon",
    additionalFormsDescription: "Additional enrollment options will be available here.",
    enrollmentAcknowledgmentError: "Please add at least one student and confirm authority acknowledgment.",
    enrollmentError: "There was a problem submitting the enrollments.",
    enrollmentAcknowledgment: "I confirm I have the authority to enroll these students.",
    dateOfBirth: "Date of Birth",
    male: "Male",
    female: "Female",
    primaryLanguage: "Primary Language",
    schoolName: "School Name",
    currentGrade: "Current Grade",
    takesMedications: "Takes Medications During Program?",
    healthConditions: "Health Conditions (Check all that apply):",
    allergies: "Allergies (Check all that apply):",
    physicalRestrictions: "Any physical restrictions or health problems?",
    additionalComments: "Additional Comments",
    reviewStudentInfo: "Review Student Information",
    previous: "Previous",
    addAnotherStudent: "Add Another Student",
    submitting: "Submitting...",
    liabilityWaiver: "Liability Waiver Agreement",
    waiverContent1: "At REFUGEE RESOURCES, INC we do all that we can to ensure...",
    waiverContent2: "It is mandatory that this form be filled out...",
    initialAgreement: "I have read and agree to the terms above (Initial)",
    printedName: "Printed Name",
    signature: "Signature",
    student: "Student",
    gender: "Gender",
    yes: "Yes",
    no: "No",
    removeStudent: "Remove Student",
    continueToWaiver: "Continue to Waiver",
    date: "Date",
    continueToReview: "Continue to Review",
    edit: "Edit",
    iAcknowledge: "I acknowledge that all information provided is accurate",
    submitAll: "Submit All",
    enrollmentSuccess: "Enrollment submitted successfully!",
    healthConditionsRespiratory: "Respiratory",
    healthConditionsAsthma: "Asthma",
    healthConditionsCysticFibrosis: "Cystic Fibrosis",
    healthConditionsNeurological: "Neurological",
    healthConditionsAdhd: "ADHD",
    healthConditionsAsd: "Autism Spectrum Disorder",
    healthConditionsConvulsions: "Convulsions",
    healthConditionsSeizures: "Seizures",
    healthConditionsMentalHealth: "Mental Health",
    healthConditionsAnxiety: "Anxiety",
    healthConditionsDepression: "Depression",
    healthConditionsSensory: "Sensory",
    healthConditionsHearingImpairment: "Hearing Impairment",
    healthConditionsVisionImpairment: "Vision Impairment",
    healthConditionsOther: "Other",
    healthConditionsDiabetes: "Diabetes",
    healthConditionsHeartDisease: "Heart Disease",
    healthConditionsBleedingClottingDisorder: "Bleeding Clotting Disorder",
    healthConditionsNone: "None",
    healthConditionsOtherSpecified: "Other (please specify)",
    allergiesFood: "Food Allergies",
    allergiesPeanuts: "Peanuts",
    allergiesTreeNuts: "Tree Nuts",
    allergiesShellfish: "Shellfish",
    allergiesWheat: "Wheat",
    allergiesSoy: "Soy",
    allergiesEggs: "Eggs",
    allergiesMilk: "Milk",
    allergiesSesame: "Sesame",
    allergiesEnvironmental: "Environmental Allergies",
    allergiesPoisonIvy: "Poison Ivy",
    allergiesPollen: "Pollen",
    allergiesInsectStings: "Insect Stings",
    allergiesMedical: "Medical Allergies",
    allergiesPenicillin: "Penicillin",
    allergiesLatex: "Latex",
    allergiesNone: "None",
    allergiesOtherSpecified: "Other (please specify)",
    physicalRestrictionsQuestion: "Does student have any physical restrictions or potential health problems?",
    waiverTitle: "REFUGEE RESOURCES",
    waiverSubtitle: "Empowering Through Literacy",
    waiverProgramTitle: "Reading Circle & Preschool Circle",
    waiverFormTitle: "Liability Form 2025-2026",
    waiverParagraph1: "At REFUGEE RESOURCES, INC. we do all that we can to ensure that your child has not only a learning experience but also a fun experience!",
    waiverParagraph2: "It is mandatory that this form be filled out, signed and dated by the parents(s) or legal guardians of the student (s) and returned.",
    waiverParagraph3: "Your student will not be permitted to attend any events unless we have received this form.",
    initialIfYouAgree: "Initial if you agree:",
    thisIsRequired: "(This is required)",
    waiverBullet1: "I understand that video and pictures are frequently taken during various events at Refugee Resources, Inc. I hereby give my permission for Refugee Resources to use photos and videos of my student for the promotion of Refugee Resources, Inc. including, but not limited to use in organizational websites, social media and brochures.",
    waiverBullet2: "I understand that Refugee Resources, Inc. is a Christian organization and give permission to Refugee Resources to teach Biblical Stories to my student.",
    waiverBullet3: "I give permission to Refugee Resources, Inc staff to enforce acceptable disciplinary action that may be necessary if my student (s) commit (s) or attempt (s) to commit any misconduct or unacceptable behavior at Refugee Resources, Inc. Consequences include but are not limited to time out, discussions with the Site teacher/ Program Director, notifying parents and requests the student leave the program for the safety and well-being of other students as a whole (in this instance mentors will ask parents to escort student back to their home.)",
    waiverBullet4: "In signing this document, I hereby certify that I give permission to my child to participate in the Reading Circle program and any of the programs or activities sponsored by Refugee Resources, Inc. I understand that the terms herein are contractual.",
    waiverParagraph4: "BY EXECUTION OF THIS DOCUMENT, I KNOWINGLY AND WILLINGLY RELEASE REFUGEE RESOURCES, INC, THE STAFF, THE BOARD, THE VOLUNTEERS (MENTORS) AND ALL OTHERS ACTING FOR OR ON BEHALF OF REFUGEE RESOURCES, INC. FROM ALL LIABILITY WHATSOEVER, FOR PERSONAL INJURY, OR INJURIES TO PROPERTY CAUSED BY, OR ARISING OUT OF PARTICIPATING IN AN EVENT WITH REFUGEE RESOURCES, INC.",
    waiverAuthorizationTitle: "Authorization for Treatment:",
    waiverAuthorizationText: "I hereby authorize the medical personnel selected by Refugee Resources, Inc. to order X-rays, routine, tests, treatment, and necessary transportation for my child. In the event I cannot be reached in an emergency, I hereby authorize the physician selected by Refugee Resources, Inc. to secure and administer treatment, including hospitalization, for my child as named above."
  },
  my: { // Burmese
    acknowledgeLabel: "ကျွန်ုပ် အသိအမှတ်ပြုပါသည်",
    acknowledgment: "ဆက်လက် လုပ်ဆောင်ခြင်းအားဖြင့်၊ ပေးထားသော အကြောင်းအရာအချက်အလက်များ အားလုံးသည် သင် သိသမျှ အကောင်းဆုံး တိကျမှန်ကန်ပြီး သင့်လျော်သော ဝန်ဆောင်မှုများကို ထောက်ပံ့ရန် အသုံးပြု နိုင်ကြောင်း သင် အသိအမှတ်ပြုသည် ။",
    addAnotherStudent: "နောက်ထပ် ကျောင်းသားတစ်ဦးကို ထပ်ထည့်ပါ",
    additionalComments: "ထပ်ဆင့် မှတ်ချက်များ",
    additionalFormsDescription: "ထပ်ဆင့် စာရင်းသွင်း ရွေးချယ်မှုများကို ဤ နေရာတွင် ရရှိ နိုင်ပါလိမ့်မည် ။",
    allergies: "ဓာတ်မတည့်မှုများ (သက်ဆိုင်သည့်အရာအားလုံးကို စစ်ဆေးပါ)-",
    allergiesEggs: "ကြက်ဥများ",
    allergiesEnvironmental: "ပတ်ဝန်းကျင်ဆိုင်ရာ ဓာတ်မတည့်မှုများ",
    allergiesFood: "အစားအစာ ဓာတ်မတည့်ခြင်းများ",
    allergiesInsectStings: "ပိုးကောင် ကိုက်ခြင်းများ",
    allergiesLatex: "ရာဘာကဲ့သို့သော လေးတက်စ် (Latex)",
    allergiesMedical: "ဆေးဘက်ဆိုင်ရာ ဓာတ်မတည့်မှုများ",
    allergiesMilk: "နို့",
    allergiesNone: "မရှိ",
    allergiesOtherSpecified: "အခြား (ကျေးဇူးပြု၍ ဖော်ပြပါ)",
    allergiesPeanuts: "မြေပဲ",
    allergiesPenicillin: "ပင်နီဆီလင်",
    allergiesPoisonIvy: "အဆိပ်ရှိသော အိုင်ဗီပင်",
    allergiesPollen: "ပန်းဝတ်မှုန်",
    allergiesSesame: "နှမ်း",
    allergiesShellfish: "အခွံမာရေသတ္တဝါများ",
    allergiesSoy: "ပဲပိစပ်",
    allergiesTreeNuts: "သစ်ပင်မှ အခွံမာအသီးများ",
    allergiesWheat: "ဂျုံ",
    apartment: "တိုက်ခန်း",
    appTitle: "ဒုက္ခသည် အရင်းအမြစ်များ",
    aptName: "တိုက်ခန်း အမည်",
    aptNumber: "တိုက်ခန်း နံပါတ်",
    arrival: "ရောက်ရှိသည့် ရက်စွဲ",
    back: "နောက်ပြန်",
    background: "နောက်ခံ",
    backgroundStep: "နောက်ခံ",
    beginForm: "ပုံစံ စတင်ပါ",
    cancel: "ပယ်ဖျက်ပါ",
    chooseLanguage: "ကျေးဇူးပြု၍ သင်နှစ်သက်သော ဘာသာစကားကို ရွေးချယ်ပါ။",
    city: "မြို့ ",
    complete: "ပြီးပြည့်စုံ",
    completeProfile: "သင့်ကိုယ်ရေးရာဇဝင်ကို ဖြည့်စွက်ပါ",
    continueToReview: "ဆက်လက်၍ ပြန်လည်သုံးသပ်ပါ",
    continueToWaiver: "ဆက်လက်၍ ကင်းလွတ်ခွင့်ပေးပါ",
    currentGrade: "လက်ရှိ အတန်း",
    date: "ရက်စွဲ",
    dateOfBirth: "မွေးနေ့သက္ကရာဇ်",
    dwelling: "နေအိမ် အမျိုးအစား",
    edit: "တည်းဖြတ်ပါ",
    editProfile: "သင့်ကိုယ်ရေးရာဇဝင်ကို တည်းဖြတ်ပါ",
    enrollmentAcknowledgment: "ကျွန်ုပ် ဤကျောင်းသားများကို စာရင်းသွင်းရန် အခွင့်အာဏာရှိကြောင်း အတည်ပြုပါသည်။",
    enrollmentAcknowledgmentError: "ကျေးဇူးပြု၍ အနည်းဆုံး ကျောင်းသားတစ်ဦးကို ထပ်ထည့် ပြီး အခွင့်အာဏာရှိကြောင်း အသိအမှတ်ပြုမှုကို အတည်ပြုပါ ။",
    enrollmentError: "စာရင်းသွင်းခြင်းတွင် ပြဿနာ တစ်ခု ရှိခဲ့ပါသည် ။",
    enrollmentSuccess: "စာရင်းသွင်းခြင်း အောင်မြင်စွာ တင်သွင်းခဲ့ပါသည် ။",
    female: "အမျိုးသမီး",
    firstName: "ပထမ အမည်",
    footerText: "ဘဝများ ပြောင်းလဲပေးနေခြင်း၊ တစ်ကြိမ်လျှင် ကလေးတစ်ယောက်စီ",
    gender: "ကျားမ",
    guardian: "အုပ်ထိန်းသူ",
    healthConditions: "ကျန်းမာရေးအခြေအနေများ (သက်ဆိုင်သည့် အရာအားလုံးကို စစ်ဆေးပါ) -",
    healthConditionsAdhd: "အေဒီအိပ်ခ်ျဒီ (ADHD)",
    healthConditionsAnxiety: "စိုးရိမ်ပူပန်မှု",
    healthConditionsAsd: "အော်တစ်ဇမ် အပိုင်းအခြား (Austism Spectrum) မူမမှန်ခြင်း",
    healthConditionsAsthma: "ပန်းနာရင်ကျပ်",
    healthConditionsBleedingClottingDisorder: "သွေးထွက် သွေးခဲမှု မူမမှန်ခြင်း",
    healthConditionsConvulsions: "တက်ခြင်းများ",
    healthConditionsCysticFibrosis: "မျိုးရိုးလိုက် အဆုတ် အစာလမ်းကြောင်းနှင့် အခြားကိုယ်အင်္ဂါများဆိုင်ရာ ရောဂါ (Cystic Fibrosis)",
    healthConditionsDepression: "စိတ်ကျ ဝေဒနာ",
    healthConditionsDiabetes: "ဆီးချိုသွေးချို",
    healthConditionsHearingImpairment: "အကြားအာရုံ ချို့ယွင်းခြင်း",
    healthConditionsHeartDisease: "နှလုံး ရောဂါ",
    healthConditionsMentalHealth: "စိတ်ကျန်းမာရေး",
    healthConditionsNeurological: "အာရုံကြောဆိုင်ရာ",
    healthConditionsNone: "မရှိ",
    healthConditionsOther: "အခြား",
    healthConditionsOtherSpecified: "အခြား (ကျေးဇူးပြု၍ ဖော်ပြပါ)",
    healthConditionsRespiratory: "အသက်ရှုလမ်းကြောင်းဆိုင်ရာ",
    healthConditionsSeizures: "ရုတ်တရက် တက်ခြင်းများ",
    healthConditionsSensory: "အာရုံခံမှု",
    healthConditionsVisionImpairment: "အမြင်အာရုံ ချို့ယွင်းခြင်း",
    house: "လုံးချင်းအိမ်",
    housing: "သင် ဘယ်မှာနေလဲ။?",
    housingInfo: "နေအိမ်ဆိုင်ရာ အကြောင်းအရာ အချက်အလက်များ",
    housingInfoStep: "နေအိမ်ဆိုင်ရာ အကြောင်းအရာ အချက်အလက်များ",
    iAcknowledge: "ပေးထားသော အကြောင်းအရာ အချက်အလက်များ အားလုံးသည် တိကျမှန်ကန်ကြောင်း ကျွန်ုပ် အသိအမှတ်ပြုပါသည်",
    initialAgreement: "ကျွန်ုပ် အထက်ပါစည်းကမ်းချက်များကို ဖတ်ရှုပြီး သဘောတူပါသည် (အမည်အတိုကောက်)",
    initialIfYouAgree: "သင်သဘောတူပါက အမည်အတိုကောက်ရေးပါ –",
    journey: "ကျွန်ုပ်တို့ကို သင့်ခရီးစဉ်အကြောင်း ပြောပြပါ",
    language: "ဘာသာစကား",
    languagePref: "ဘာသာစကား ဦးစားပေးချက်များ",
    languageStep: "ဘာသာစကား",
    lastName: "နောက်ဆုံး အမည်",
    liabilityWaiver: "တာဝန် ကင်းလွတ်ခွင့် သဘောတူချက်",
    male: "အမျိုးသား",
    moreFormsComing: "နောက်ထပ် ပုံစံများ မကြာမီ လာပါလိမ့်မည်",
    next: "နောက်",
    no: "မဟုတ်ပါ",
    office: "ရုံးခန်းတည်နေရာ (စေတနာ့ဝန်ထမ်းများအတွက်)",
    origin: "နေရင်း နိုင်ငံ",
    parent: "မိဘ",
    personalInfo: "ပုဂ္ဂိုလ်ရေးဆိုင်ရာ အကြောင်းအရာ အချက်အလက်များ",
    personalInfoStep: "ပုဂ္ဂိုလ်ရေးဆိုင်ရာ အကြောင်းအရာ အချက်အလက်များ",
    phone: "ဖုန်းနံပါတ်",
    physicalRestrictions: "ကာယဆိုင်ရာ ကန့်သတ်ချက်များ သို့မဟုတ် ကျန်းမာရေးပြဿနာများ ရှိပါသလား။",
    physicalRestrictionsQuestion: "ကျောင်းသားမှာ ကာယဆိုင်ရာ ကန့်သတ်ချက်များ သို့မဟုတ် ကျန်းမာရေးပြဿနာများ ရှိပါသလား။",
    preferredLang: "နှစ်သက် သော ဘာသာစကား",
    preschoolCircleDescription: "အောင်မြင်သော ပညာရေး ခရီးစဉ်များအတွက် ငယ်ရွယ် သော သင်ယူသူများကို ပြင်ဆင်ပေးခြင်းကို အာရုံစိုက် သော ကျွန်ုပ်တို့၏ အစောပိုင်း ပညာရေး အစီအစဉ်တွင် ကလေးများကို စာရင်းသွင်းပါ။",
    preschoolCircleEnrollment: "မူကြိုကျောင်း အသိုင်းအဝိုင်း စာရင်းသွင်းခြင်း",
    previous: "ယခင်",
    primaryLanguage: "မူလ ဘာသာစကား",
    printedName: "မြင်သာထင်ရှားစွာရေးသော အမည်",
    readingCircleDescription: "စာတတ်မြောက်နိုင်စွမ်းကို တည်ဆောက်ရန်နှင့် စာဖတ်လိုစိတ်ကို ပြုစုပျိုးထောင်ရန် ရည်ရွယ်ထားသော စာဖတ်အစီအစဉ်တွင် ကလေးများကို စာရင်းသွင်းပါ။",
    readingCircleEnrollment: "စာဖတ် အသိုင်းအဝိုင်း စာရင်းသွင်းခြင်း",
    refugee: "ဒုက္ခသည်",
    removeStudent: "ကျောင်းသားကို ဖယ်ရှားပါ",
    reviewStudentInfo: "ကျောင်းသား အကြောင်းအရာ အချက်အလက်များကို ပြန်လည်သုံးသပ်ပါ",
    roleLabel: "ကျွန်ုပ်သည်...",
    saving: "သိမ်းဆည်းထားခြင်း...",
    schoolName: "ကျောင်းအမည်",
    selectFormPrompt: "ကျေးဇူးပြု၍ စတင်ရန် ပုံစံတစ်ခုကို ရွေးချယ်ပါ။",
    selectLanguage: "သင့် ဘာသာစကားကို ရွေးချယ်ပါ",
    signature: "လက်မှတ်",
    signOut: "ထွက်သွားပါ",
    street: "လမ်း လိပ်စာ",
    student: "ကျောင်းသား",
    submitAll: "အားလုံးကို တင်သွင်းပါ",
    submitting: "တင်သွင်းနေသည်...",
    takesMedications: "အစီအစဉ်အတွင်း ဆေးဝါးသုံးစွဲပါသလာ။",
    team: "အဖွဲ့ (စေတနာ့ဝန်ထမ်းများအတွက်)",
    thisIsRequired: "၎င်းသည် လိုအပ်ပါသည)",
    volunteer: "စေတနာ့ဝန်ထမ်း",
    volunteerInfo: "ကျွန်ုပ်တို့ကို သင် မည်သည့်နေရာမှာ အမှုဆောင်သည်ကို ပြောပြပါ။",
    waiverAuthorizationText: "ဒုက္ခသည် အရင်းအမြစ်များ ကုမ္ပဏီက ရွေးချယ်ထားသော ဆေးဘက်ဆိုင်ရာဝန်ထမ်းများအား ကျွန်ုပ်၏ ကလေးအတွက် ဓာတ်မှန်ရိုက်ခြင်း၊ ပုံမှန်စစ်ဆေးခြင်း၊ ကုသမှုနှင့် လိုအပ်သောသယ်ယူပို့ဆောင်ရေးကို အခွင့်အာဏာ ပေးပါသည်။ အရေးပေါ်အခြေအနေမှာ ကျွန်ုပ်ကို မဆက်သွယ်နိုင်ပါက ဒုက္ခသည်အရင်းအမြစ် ကုမ္ပဏီက ရွေးချယ်ထားသော ဆရာဝန်ကို အထက်မှာဖော်ပြထားသည့်အတိုင်း ကျွန်ုပ်၏ကလေးအတွက် ဆေးရုံတက်ခြင်းအပါအဝင် ကုသမှုကို လုံခြုံစေပြီး စီမံခန့်ခွဲပေးရန် ကျွန်ုပ် အခွင့်အာဏာ ပေးပါသည်။",
    waiverAuthorizationTitle: "ကုသမှုအတွက် အခွင့်အာဏာပေးခြင်း –",
    waiverBullet1: "ဒုက္ခသည် အရင်းအမြစ်များ ကုမ္ပဏီမှာ ဖြစ်ရပ်အမျိုးမျိုးမှာ ဗီဒီယိုနဲ့ ဓာတ်ပုံတွေကို မကြာခဏ ရိုက်ယူကြောင်း ကျွန်ုပ် နားလည်ပါသည်။ ဒုက္ခသည် အရင်းအမြစ်များအတွက် အဖွဲ့အစည်းဝက်ဘ်ဆိုက်များ၊ လူမှုမီဒီယာနှင့် လက်ကမ်းစာစောင်များတွင် အသုံးပြုရန် အကန့်အသတ်မရှိ ဒုက္ခသည် အရင်းအမြစ်များအတွက် ကျွန်ုပ်၏ ကျောင်းသား၏ ဓာတ်ပုံများနှင့် ဗီဒီယိုများကို အသုံးပြုရန် ခွင့်ပြုပါသည်။",
    waiverBullet2: "ဒုက္ခသည် အရင်းအမြစ်များ ကုမ္ပဏီသည် ခရစ်ယာန်အဖွဲ့အစည်းတစ်ခုဖြစ်ကြောင်း ကျွန်ုပ်နားလည်ပြီး ကျွန်ုပ်၏ ကျောင်းသားကို ကျမ်းစာပုံပြင်တွေကို သင်ကြာပေးန် ဒုက္ခသည် အရင်းအမြစ်များကို ခွင့်ပြုပါသည်။",
    waiverBullet3: "ဒုက္ခသည် အရင်းအမြစ်များ ကုမ္ပဏီ တွင် ကျွန်ုပ်၏ ကျောင်းသား (များ) သည် မည်သည့် မှားယွင်းသော အပြုအမူ သို့မဟုတ် လက်မခံနိုင်သော အပြုအမူများကို ကျူးလွန်ခြင်း သို့မဟုတ် ကျူးလွန်ရန် လုပ်ဆောင်ခဲ့လျှင် လိုအပ်သော လက်ခံနိုင်သော စည်းကမ်း ဥပဒေဆိုင်ရာ အရေးယူမှုကို ဆောင်ရွက် ရန် ဒုက္ခသည် အရင်းအမြစ်များ၏ ဝန်ထမ်းကို ကျွန်ုပ် ခွင့်ပြုပါသည်။ အကျိုးဆက်များတွင် ဆိုင်းငံ့ခြင်း၊ ဆိုင်ရာဆရာ / အစီအစဉ် ဒါရိုက်တာ နှင့် ဆွေးနွေးခြင်း၊ မိဘများကို အသိပေးခြင်း နှင့် အခြား ကျောင်းသားများ၏ လုံခြုံမှုနှင့် ကောင်းကျိုးအတွက် ကျောင်းသားကို အစီအစဉ်မှ ထွက်ခွာသွားရန် တောင်းဆို ခြင်းတို့ ပါဝင် သော်လည်း ကန့်သတ်မှုမရှိပါ (ဥပမာ နည်းပြများက ကျောင်းသားကို သူတို့၏ အိမ်သို့ ပြန်ခေါ်ရန် မိဘများကို တောင်းဆိုလိမ့်မည်။)",
    waiverBullet4: "ဤစာရွက်စာတမ်းကို လက်မှတ်ရေးထိုးခြင်းအားဖြင့် ကျွန်ုပ်၏ကလေးအား စာဖတ် အသိုင်းအဝိုင်း အစီအစဉ်နှင့် ဒုက္ခသည် အရင်းအမြစ်များ ကုမ္ပဏီမှ ထောက်ပံ့ပေးသော မည်သည့်အစီအစဉ် သို့မဟုတ် လှုပ်ရှားမှုတွင်မဆို ပါဝင်ခွင့်ပြုကြောင်း ကျွန်ုပ် အတည်ပြုပါသည်။ ဤ စာရွက်စာတမ်းတွင်ပါသော စည်းကမ်းချက်များသည် စာချုပ်ဆိုင်ရာ ဖြစ်ကြောင်း ကျွန်ုပ် နားလည်ပါသည်။",
    waiverContent1: "ဒုက္ခသည် အရင်းအမြစ်များ ကုမ္ပဏီတွင် ကျွန်ုပ်တို့ သည် တတ်နိုင်သမျှ သေချာစေရန် ကျွန်ုပ်တို့ လုပ်ဆောင်ပါသည်...",
    waiverContent2: "ဤပုံစံကို မဖြစ်မနေ ဖြည့်စွက်ရန်ဖြစ်ပါသည်...",
    waiverFormTitle: "တာဝန်ရှိမှု ပုံစံ ၂၀၂၅-၂၀၂၆",
    waiverParagraph1: "ဒုက္ခသည် အရင်းအမြစ်များ ကုမ္ပဏီတွင် သင့်ကလေးသည် သင်ယူမှုအတွေ့အကြုံသာမက ပျော်ရွှင်စရာအတွေ့အကြုံ ကိုလည်း ရရှိစေရန် ကျွန်ုပ်တို့ အတတ်နိုင်ဆုံး လုပ်ဆောင်ပါသည်!",
    waiverParagraph2: "ကျောင်းသား (များ) ၏ မိဘများ သို့မဟုတ် တရားဝင် အုပ်ထိန်းသူများက ဤ ပုံစံ ကို ဖြည့်စွက် ၊ လက်မှတ်ထိုး ပြီး ရက်စွဲတပ်ပြီး ပြန်ပို့ ရန် မဖြစ်မနေ လိုအပ်ပါသည် ။",
    waiverParagraph3: "ဤပုံစံကို ကျွန်ုပ်တို့ မရရှိလျှင် သင့်ကျောင်းသားကို မည်သည့်ပွဲကိုမဆို တက်ရောက်ခွင့်မပြုပါ။",
    waiverParagraph4: "ဤစာရွက်စာတမ်းကို အကောင်အထည်ဖော်ခြင်းဖြင့် ဒုက္ခသည်အရင်းအမြစ်များ ကုမ္ပဏီ၊ ဝန်ထမ်းများ၊ ဘုတ်အဖွဲ့၊ စေတနာ့ဝန်ထမ်းများ (အကြံပေးသူများ) နှင့် ဒုက္ခသည် အရင်းအမြစ်များ ကုမ္ပဏီအတွက် သို့မဟုတ် ကိုယ်စားပြုသော အခြားသူများအားလုံးကို ကျွန်ုပ် အသိရှိရှိနှင့် လိုလိုလားလား လွှတ်ငြိမ်းခွင့်ပေးပါသည်။ ပုဂ္ဂိုလ်ရေးဆိုင်ရာ ထိခိုက်ဒဏ်ရာများ ၊ သို့မဟုတ် ဒုက္ခသည် အရင်းအမြစ် များ ကုမ္ပဏီ နှင့်အတူ ဖြစ်ရပ် တစ်ခုတွင် ပါဝင် ခြင်းကြောင့် ဖြစ်ပေါ်လာ သောပစ္စည်းဥစ္စာ ထိခိုက်မှုများအတွက် မည်သည့်တာဝန်မှမဆို ဖြစ်ပါသည်။",
    waiverProgramTitle: "စာဖတ် အသိုင်းအဝိုင်း နှင့် မူကြိုကျောင်း အသိုင်းအဝိုင်း",
    waiverSubtitle: "စာတတ်မြောက်ခြင်းမှတစ်ဆင့် စွမ်းအားပေးခြင်း",
    waiverTitle: "ဒုက္ခသည် အရင်းအမြစ်များ",
    welcome: "ကြိုဆိုပါသည်! ကျွန်ုပ်တို့ကို သင့်အကြောင်း ပြောပြပါ။",
    welcomeForm: "ကြိုဆိုပါသည်",
    yes: "ဟုတ်ပါသည်",
    zip: "စာတိုက်သင်္ကေတ ဇစ်ကုဒ် (Zip Code)",
  },
  fr: { // French
    acknowledgeLabel: "Je reconnais",
    acknowledgment: "En continuant, vous reconnaissez que toutes les informations fournies sont exactes à votre connaissance et peuvent être utilisées pour vous offrir des services appropriés.",
    addAnotherStudent: "Ajouter un(e) autre élève",
    additionalComments: "Commentaires supplémentaires",
    additionalFormsDescription: "D’autres options d’inscription seront disponibles ici.",
    allergies: "Allergies (cocher tout ce qui s’applique) :",
    allergiesEggs: "Œufs",
    allergiesEnvironmental: "Allergies environnementales",
    allergiesFood: "Allergies alimentaires",
    allergiesInsectStings: "Piqûres d’insectes",
    allergiesLatex: "Latex",
    allergiesMedical: "Allergies médicales",
    allergiesMilk: "Lait",
    allergiesNone: "Aucun(e)",
    allergiesOtherSpecified: "Autre (veuillez préciser)",
    allergiesPeanuts: "Cacahuètes",
    allergiesPenicillin: "Pénicilline",
    allergiesPoisonIvy: "Sumac vénéneux",
    allergiesPollen: "Pollen",
    allergiesSesame: "Sésame",
    allergiesShellfish: "Fruits de mer",
    allergiesSoy: "Soja",
    allergiesTreeNuts: "Fruits à coque",
    allergiesWheat: "Blé",
    apartment: "Appartement",
    appTitle: "Refugee Resources",
    aptName: "Nom de l’appartement",
    aptNumber: "Numéro de l’appartement",
    arrival: "Date d’arrivée",
    back: "Précédent",
    background: "Contexte",
    backgroundStep: "Contexte",
    beginForm: "Commencer le formulaire",
    cancel: "Annuler",
    chooseLanguage: "Veuillez sélectionner votre langue préférée :",
    city: "Ville",
    complete: "Terminer",
    completeProfile: "Compléter votre profil",
    continueToReview: "Continuer vers l’examen",
    continueToWaiver: "Continuer vers la décharge de responsabilité",
    currentGrade: "Niveau actuel",
    date: "Date",
    dateOfBirth: "Date de naissance",
    dwelling: "Type de logement",
    edit: "Modifier",
    editProfile: "Modifier votre profil",
    enrollmentAcknowledgment: "Je confirme que j’ai le pouvoir d’inscrire ces élèves.",
    enrollmentAcknowledgmentError: "Veuillez ajouter au moins un(e) élève et confirmer que vous avez le pouvoir de le faire.",
    enrollmentError: "Un problème est survenu lors de l’envoi des inscriptions.",
    enrollmentSuccess: "Inscription envoyée avec succès !",
    female: "Féminin",
    firstName: "Prénom",
    footerText: "Transformer des vies, un enfant à la fois",
    gender: "Sexe",
    guardian: "Tuteur",
    healthConditions: "Problèmes de santé (cocher tout ce qui s’applique) :",
    healthConditionsAdhd: "TDAH",
    healthConditionsAnxiety: "Anxiété",
    healthConditionsAsd: "Trouble du spectre autistique",
    healthConditionsAsthma: "Asthme",
    healthConditionsBleedingClottingDisorder: "Trouble de la coagulation sanguine",
    healthConditionsConvulsions: "Convulsions",
    healthConditionsCysticFibrosis: "Mucoviscidose",
    healthConditionsDepression: "Dépression",
    healthConditionsDiabetes: "Diabète",
    healthConditionsHearingImpairment: "Déficience auditive",
    healthConditionsHeartDisease: "Maladie cardiaque",
    healthConditionsMentalHealth: "Santé mentale",
    healthConditionsNeurological: "Neurologique",
    healthConditionsNone: "Aucun(e)",
    healthConditionsOther: "Autre",
    healthConditionsOtherSpecified: "Autre (veuillez préciser)",
    healthConditionsRespiratory: "Respiratoire",
    healthConditionsSeizures: "Crises",
    healthConditionsSensory: "Sensoriel",
    healthConditionsVisionImpairment: "Déficience visuelle",
    house: "Maison",
    housing: "Où habitez-vous ?",
    housingInfo: "Informations sur le logement",
    housingInfoStep: "Informations sur le logement",
    iAcknowledge: "Je reconnais que toutes les informations fournies sont exactes",
    initialAgreement: "J’ai lu et j’accepte les conditions ci-dessus (parapher)",
    initialIfYouAgree: "Paraphez si vous êtes d’accord :",
    journey: "Parlez-nous de votre parcours",
    language: "Langue",
    languagePref: "Préférences linguistiques",
    languageStep: "Langue",
    lastName: "Nom de famille",
    liabilityWaiver: "Accord de décharge de responsabilité",
    male: "Masculin",
    moreFormsComing: "Plus de formulaires à venir",
    next: "Suivant",
    no: "Non",
    office: "Emplacement du bureau (pour les bénévoles)",
    origin: "Pays d’origine",
    parent: "Parent",
    personalInfo: "Renseignements personnels",
    personalInfoStep: "Renseignements personnels",
    phone: "Numéro de téléphone",
    physicalRestrictions: "Restrictions physiques ou problèmes de santé ?",
    physicalRestrictionsQuestion: "L’élève a-t-il/elle des restrictions physiques ou des problèmes de santé potentiels ?",
    preferredLang: "Langue préférée",
    preschoolCircleDescription: "Inscrivez vos enfants à notre programme d’éducation préscolaire axé sur la préparation des jeunes apprenants à la réussite scolaire.",
    preschoolCircleEnrollment: "Inscription au programme Cercle préscolaire",
    previous: "Précédent",
    primaryLanguage: "Langue maternelle",
    printedName: "Nom en caractères d’imprimerie",
    readingCircleDescription: "Inscrivez vos enfants à notre programme de lecture conçu pour développer les compétences en matière de lecture et leur donner le goût de la lecture.",
    readingCircleEnrollment: "Inscription au programme Cercle de lecture",
    refugee: "Réfugié",
    removeStudent: "Supprimer l’élève",
    reviewStudentInfo: "Examiner les informations sur l’élève",
    roleLabel: "Je suis un(e)...",
    saving: "Enregistrement en cours...",
    schoolName: "Nom de l’école",
    selectFormPrompt: "Veuillez sélectionner un formulaire pour commencer :",
    selectLanguage: "Sélectionnez votre langue",
    signature: "Signature",
    signOut: "Se déconnecter",
    street: "Adresse",
    student: "Élève",
    submitAll: "Tout envoyer",
    submitting: "Envoi en cours...",
    takesMedications: "Prend-il/elle des médicaments pendant le programme ?",
    team: "Équipe (pour les bénévoles)",
    thisIsRequired: "(Ceci est obligatoire)",
    volunteer: "Bénévole",
    volunteerInfo: "Dites-nous où vous offrez vos services.",
    waiverAuthorizationText: "Par la présente, j’autorise le personnel médical sélectionné par Refugee Resources, Inc. à demander des radiographies, des tests courants, des traitements et le transport nécessaire pour mon enfant. Dans l’éventualité où je ne pourrais pas être joint(e) en cas d’urgence, j’autorise par la présente le médecin choisi par Refugee Resources, Inc. à assurer et à administrer un traitement, y compris une hospitalisation, pour mon enfant dont le nom figure ci-dessus.",
    waiverAuthorizationTitle: "Autorisation de traitement :",
    waiverBullet1: "Je comprends que des vidéos et des photos sont fréquemment prises lors de divers événements à Refugee Resources, Inc. Par la présente, j’autorise Refugee Resources à utiliser des photos et des vidéos de mon enfant à des fins promotionnelles, y compris, mais sans s’y limiter, sur les sites internet, les réseaux sociaux et les brochures de l’organisation.",
    waiverBullet2: "Je comprends que Refugee Resources, Inc. est une organisation chrétienne et j’autorise Refugee Resources à enseigner des histoires bibliques à mon enfant.",
    waiverBullet3: "J’autorise le personnel de Refugee Resources, Inc. à prendre les mesures disciplinaires acceptables qui pourraient être nécessaires si mon ou mes enfants commettent ou tentent de commettre une faute ou ont un comportement inacceptable à Refugee Resources, Inc. Les conséquences comprennent, mais sans s’y limiter, une exclusion temporaire, une discussion avec l’enseignant du site ou le directeur du programme, la notification des parents et la demande à l’élève de quitter le programme pour la sécurité et le bien-être des autres élèves (dans ce cas, les mentors demanderont aux parents d’accompagner l’élève à son domicile.)",
    waiverBullet4: "En signant ce document, je certifie par la présente que j’autorise mon enfant à participer au programme Cercle de lecture et à tout programme ou à toute activité parrainés par Refugee Resources, Inc. Je comprends que les conditions énoncées dans le présent document sont contractuelles.",
    waiverContent1: "À REFUGEE RESOURCES, INC., nous faisons tout notre possible pour garantir...",
    waiverContent2: "Ce formulaire doit obligatoirement être rempli...",
    waiverFormTitle: "Formulaire de responsabilité 2025-2026",
    waiverParagraph1: "À REFUGEE RESOURCES, INC., nous faisons tout notre possible pour garantir que votre enfant vive non seulement une expérience enrichissante, mais également une expérience amusante !",
    waiverParagraph2: "Ce formulaire doit obligatoirement être rempli, signé et daté par le ou les parents ou tuteurs légaux du ou des élèves, puis être renvoyé.",
    waiverParagraph3: "Votre enfant ne sera autorisé à participer à aucun événement tant que nous n’aurons pas reçu ce formulaire.",
    waiverParagraph4: "EN SIGNANT CE DOCUMENT, JE DÉGAGE EN TOUTE CONNAISSANCE ET DE MON PROPRE GRÉ REFUGEE RESOURCES, INC., SON PERSONNEL, SON CONSEIL D’ADMINISTRATION, SES BÉNÉVOLES (MENTORS) ET TOUTE AUTRE PERSONNE AGISSANT POUR LE COMPTE OU AU NOM DE REFUGEE RESOURCES, INC. DE TOUTE RESPONSABILITÉ, QUELLE QU’ELLE SOIT, EN CAS DE BLESSURES CORPORELLES, OU DE DOMMAGES MATÉRIELS CAUSÉS PAR LA PARTICIPATION À UN ÉVÉNEMENT DE REFUGEE RESOURCES, INC. OU DÉCOULANT DE CELLE-CI.",
    waiverProgramTitle: "Programmes Cercle de lecture et Cercle préscolaire",
    waiverSubtitle: "L’autonomisation par l’alphabétisation",
    waiverTitle: "REFUGEE RESOURCES",
    welcome: "Bienvenue ! Parlez-nous de vous.",
    welcomeForm: "Bienvenue",
    yes: "Oui",
    zip: "Code postal",
  },
  kar: { // Karen (Sgaw) - Burmese Script
    acknowledgeLabel: "ယသ့ၣ်ညါအၢၣ်လီၤ",
    acknowledgment: "ခီဖျိစးထီၣ်မၤတၢ်အံၤ, နသ့ၣ်ညါအၢၣ်လီၤလၢ တၢ်ဂ့ၢ်တၢ်ကျိၤလၢတၢ်ဟ့ၣ်လီၤအီၤခဲလၢာ်န့ၣ် လီၤတံၢ်လီၤဆဲးဝဲ ပၢၢ်တုၤလၢယနၢ်ပၢၢ်အီၤသ့အဂ့ၤကတၢၢ်အပတီၢ် ဒီး တၢ်ကစူးကါအီၤ ဒ်သိးကဟ့ၣ်လီၤ တၢ်တိစၢၤမၤစၢၤအကြၢးအဘၣ်တဖၣ်အဂီၢ်န့ၣ်လီၤ.",
    addAnotherStudent: "ထၢနုာ်လီၤ ကၠိဖိလၢခံတဂၤ",
    additionalComments: "တၢ်ဟ့ၣ်ထီၣ်တၢ်ထံၣ်အဂုၤအဂၤတဖၣ်",
    additionalFormsDescription: "တၢ်ဆဲးလီၤမံၤအတၢ်ဃုထၢအဂၤတဖၣ် အိၣ်ဝဲဒၣ်ဖဲအံၤန့ၣ်လီၤ.",
    allergies: "တၢ်တဖိးလိာ်သးဒီးသွံၣ်ထံ (မၤနီၣ်တၢ်လၢအဘၣ်ဃးခဲလၢာ်):",
    allergiesEggs: "ထိၣ်ဒံၣ်ဆီဒံၣ်တဖၣ်",
    allergiesEnvironmental: "ခိၣ်ဃၢၤတၢ်အိၣ်သးဂ့ၢ်ဝီ တၢ်တဖိးလိာ်သးဒီးသွံၣ်ထံတဖၣ်",
    allergiesFood: "တၢ်အီၣ်တၢ်အီဂ့ၢ်ဝီ တၢ်တဖိးလိာ်သးဒီးသွံၣ်ထံတဖၣ်",
    allergiesInsectStings: "တၢ်ဖိလံၤဖိဃၢ် အ့ၣ်တၢ်ဆဲးတၢ်တဖၣ်",
    allergiesLatex: "လ့းထဲးစ် (Latex)",
    allergiesMedical: "ကသံၣ်ကသီဂ့ၢ်ဝီ တၢ်တဖိးလိာ်သးဒီးသွံၣ်ထံတဖၣ်",
    allergiesMilk: "တၢ်နုၢ်ထံ",
    allergiesNone: "နီတမံၤ",
    allergiesOtherSpecified: "တၢ်အဂၤ (ဝံသးစူၤ ပာ်ဖျါထီၣ်)",
    allergiesPeanuts: "သဘ့ဟီၣ်လာ်တဖၣ်",
    allergiesPenicillin: "ပဲၣ်နဲၣ်စလ့ၣ်ကသံၣ် (Penicillin)",
    allergiesPoisonIvy: "တၢ်မုၢ်စွါလါဟ့ၣ်လၢအစုၣ်အိၣ် (Poison Ivy)",
    allergiesPollen: "ဖီအကမူၣ်",
    allergiesSesame: "နံၣ်သိ",
    allergiesShellfish: "ချိၣ်သဒီၣ်ဆွဲၣ်",
    allergiesSoy: "ထီနီာ်ချံ",
    allergiesTreeNuts: "သ့ၣ်အချံတဖၣ်",
    allergiesWheat: "ဘုကၠူၣ်",
    apartment: "ဟံၣ်ဒၢးဖှိၣ်",
    appTitle: "ပှၤဘၣ်ကီဘၣ်ခဲ ဂံၢ်ထံးတၢ်အိၣ်ယၢၤတဖၣ်",
    aptName: "ဟံၣ်ဒၢးဖှိၣ်အမံၤ",
    aptNumber: "ဟံၣ်ဒၢးဖှိၣ်အနီၣ်ဂံၢ်",
    arrival: "တၢ်ဟဲတုၤအမုၢ်နံၤ",
    back: "အလီၢ်ခံ",
    background: "တၢ်စံၣ်စိၤဂံၢ်ထံး",
    backgroundStep: "တၢ်စံၣ်စိၤဂံၢ်ထံး",
    beginForm: "စးထီၣ်မၤပှဲၤ လံာ်တကွီၣ်ဒိ",
    cancel: "ဆိကတီၢ်ကွံာ်",
    chooseLanguage: "ဝံသးစူၤဃုထၢ ကျိာ်လၢနဘၣ်သးအီၤအဒိၣ်ကတၢၢ်-",
    city: "ဝ့ၢ်",
    complete: "မၤပှဲၤ",
    completeProfile: "မၤပှဲၤ နနီၢ်ကစၢ်ဂ့ၢ်ကျိၤဖှိၣ်",
    continueToReview: "ဆဲးမၤ တၢ်ကွၢ်ကဒါက့ၤတၢ်",
    continueToWaiver: "ဆဲးမၤ တၢ်ပျဲဟ့ၣ်လီၤခွဲးယာ်",
    currentGrade: "တီၤအခဲအံၤ",
    date: "မုၢ်နံၤ",
    dateOfBirth: "နံၤအိၣ်ဖျဲၣ်",
    dwelling: "တၢ်အိၣ်တၢ်ဆိးအကလုာ်",
    edit: "ပဲာ်ထံ",
    editProfile: "ပဲာ်ထံ နနီၢ်ကစၢ်ဂ့ၢ်ကျိၤဖှိၣ်",
    enrollmentAcknowledgment: "ယပာ်ဂၢၢ်ပာ်ကျၢၤလၢ ယအိၣ်ဒီး တၢ်စိတၢ်ကမီၤလၢ ကဆဲးလီၤန့ၢ်ပှၤကၠိဖိတဖၣ်အံၤအမံၤန့ၣ်လီၤ.",
    enrollmentAcknowledgmentError: "ဝံသးစူၤ ထၢနုာ်လီၤဘၣ် အစှၤကတၢၢ်ပှၤကၠိဖိတဂၤ ဒီး ပာ်ဂၢၢ်ပာ်ကျၢၤ တၢ်န့ၢ်စိန့ၢ်ကမီၤ တၢ်သ့ၣ်ညါအၢၣ်လီၤတၢ်တက့ၢ်.",
    enrollmentError: "တၢ်ကမူၤကမၣ်အိၣ်ဝဲဒၣ်တမံၤလၢ တၢ်တီၣ်ထီၣ် တၢ်ဆဲးနုာ်လီၤမံၤတဖၣ်အံၤအပူၤန့ၣ်လီၤ.",
    enrollmentSuccess: "တၢ်ဆဲးနုာ်လီၤမံၤန့ၣ် တၢ်တီၣ်ထီၣ်အီၤ ဝံၤလၢပှဲၤဝဲဂ့ၤဂ့ၤဘၣ်ဘၣ်လံ!",
    female: "ပိာ်မုၣ်",
    firstName: "မံၤခီၣ်ထံး",
    footerText: "တၢ်ပျိာ်လဲတၢ်အိၣ်မူတဖၣ်, တဘျီန့ၣ်ဖိသၣ်တဂၤ",
    gender: "ကၠဲဒၢၢ်",
    guardian: "ပှၤကွၢ်ထွဲတၢ်",
    healthConditions: "ဆူၣ်ချ့ဂ့ၢ်ဝီတၢ်အိၣ်သးတဖၣ် (မၤနီၣ်တၢ်လၢဘၣ်ဃးခဲလၢာ်):",
    healthConditionsAdhd: "ADHD",
    healthConditionsAnxiety: "တၢ်သူၣ်တတုၤလီၤသးတတုၤလီၤ",
    healthConditionsAsd: "အီၣ်တံးစၢ်တၢ်ဆါပနီၣ်ဖှိၣ် (Autism Spectrum Disorder)",
    healthConditionsAsthma: "တၢ်သါအံး",
    healthConditionsBleedingClottingDisorder: "သွံၣ်ပံာ်ထီၣ်ယွၤလီၤတၢ်ဂ့ၢ်ကီ (Bleeding Clotting Disorder)",
    healthConditionsConvulsions: "တၢ်ထီၣ်တဖၣ်",
    healthConditionsCysticFibrosis: "စၢၤသွဲၣ်လီၤစၢၤပသိၣ်ဒီးကဟးဂ့ၢ်ဝီတၢ်ဆါ (Cystic Fibrosis)",
    healthConditionsDepression: "တၢ်သူၣ်ဟးဂီၤသးဟးဂီၤ",
    healthConditionsDiabetes: "ဆံၣ်ဆၢတၢ်ဆါ",
    healthConditionsHearingImpairment: "တၢ်နၢ်ဟူတၢ်ဟးဂူာ်ဟးဂီၤ",
    healthConditionsHeartDisease: "သးတၢ်ဆါ",
    healthConditionsMentalHealth: "နီၢ်သးဂ့ၢ်ဝီတၢ်အိၣ်ဆူၣ်အိၣ်ချ့",
    healthConditionsNeurological: "ခိၣ်နူာ်ဒီးနၢာ်ဘိပီညါဂ့ၢ်ဝီ",
    healthConditionsNone: "နီတမံၤ",
    healthConditionsOther: "တၢ်အဂၤ",
    healthConditionsOtherSpecified: "တၢ်အဂၤ (ဝံသးစူၤ ပာ်ဖျါထီၣ်)",
    healthConditionsRespiratory: "ကလံၤကျိၤတၢ်သါဂ့ၢ်ဝီ",
    healthConditionsSeizures: "တၢ်ထီၣ်တဖၣ်",
    healthConditionsSensory: "စ့ၣ်အတၢ်သ့ၣ်ညါဂ့ၢ်ဝီ",
    healthConditionsVisionImpairment: "မဲာ်ချံတၢ်ထံၣ်ဂ့ၢ်ဝီ တၢ်ဟးဂူာ်ဟးဂီၤ",
    house: "ဟံၣ်",
    housing: "မ့ၢ်နအိၣ်ဆိးဖဲလဲၣ်.",
    housingInfo: "ဟံၣ်ဃီတၢ်ဂ့ၢ်တၢ်ကျိၤ",
    housingInfoStep: "ဟံၣ်ဃီတၢ်ဂ့ၢ်တၢ်ကျိၤ",
    iAcknowledge: "ယသ့ၣ်ညါအၢၣ်လီၤလၢ တၢ်ဂ့ၢ်တၢ်ကျိၤလၢတၢ်ဟ့ၣ်လီၤအီၤခဲလၢာ်အံၤ လီၤတံၢ်လီၤဆဲးဝဲန့ၣ်လီၤ",
    initialAgreement: "တၢ်သိၣ်တၢ်ဘျၢလၢထးတဖၣ်န့ၣ် ယဖးကွၢ်အီၤဝံၤလံ ဒီး ယအၢၣ်လီၤတူၢ်လိာ်အီၤန့ၣ်လီၤ (ဆဲးလီၤမံၤဖုၣ်)",
    initialIfYouAgree: "ဆဲးလီၤမံၤဖုၣ် နမ့ၢ်တူၢ်လိာ်-",
    journey: "တဲပၠးပှၤ နတၢ်လဲၤကျဲ အဂ့ၢ်အကျိၤတက့ၢ်",
    language: "ကျိာ်",
    languagePref: "ကျိာ် တၢ်ဘၣ်သူၣ်ဘၣ်သးတဖၣ်",
    languageStep: "ကျိာ်",
    lastName: "မံၤလီၤစၢၤ",
    liabilityWaiver: "တၢ်ဘၣ်ဟံးမူဟံးဒါ တၢ်ပျဲဟ့ၣ်လီၤခွဲးယာ် အတၢ်အၢၣ်လီၤ",
    male: "ခွါ",
    moreFormsComing: "လံာ်တကွီၣ်ဒိအဂၤတဖၣ် တစိၢ်ဖိကဟဲဝဲန့ၣ်လီၤ",
    next: "ဆူမဲာ်ညါ",
    no: "တမ့ၢ်ဘၣ်",
    office: "ဝဲၤဒၢးအလီၢ်အကျဲ (လၢပှၤမၤတၢ်ဖိမုာ်သးမၤကလီတဖၣ်အဂီၢ်)",
    origin: "ဂံၢ်ထံး ထံကီၢ်",
    parent: "မိၢ်ပၢ်",
    personalInfo: "နီၢ်ကစၢ် တၢ်ဂ့ၢ်တၢ်ကျိၤ",
    personalInfoStep: "နီၢ်ကစၢ် တၢ်ဂ့ၢ်တၢ်ကျိၤ",
    phone: "လီတဲစိနီၣ်ဂံၢ်",
    physicalRestrictions: "နီၢ်ခိနီၢ်ကစၢ်ဂ့ၢ်ဝီ တၢ်တြီမၤတံာ်တာ်တၢ်တဖၣ် မ့တမ့ၢ် ဆူၣ်ချ့ဂ့ၢ်ဝီတၢ်ဂ့ၢ်ကီတဖၣ် အိၣ်တမံၤမံၤဧါ.",
    physicalRestrictionsQuestion: "မ့ၢ်ပှၤကၠိဖိအိၣ်ဒီး နီၢ်ခိနီၢ်ကစၢ်ဂ့ၢ်ဝီ တၢ်တြီမၤတံာ်တာ်တၢ်တဖၣ် မ့တမ့ၢ် ဆူၣ်ချ့ဂ့ၢ်ဝီတၢ်ဂ့ၢ်ကီတဖၣ် အိၣ်တမံၤမံၤဧါ.",
    preferredLang: "ကျိာ်လၢဘၣ်သးအီၤအဒိၣ်ကတၢၢ်",
    preschoolCircleDescription: "ဆဲးလီၤန့ၢ် ပှၤကၠိဖိတဖၣ်အမံၤ လၢပကတီၤဆိကူၣ်သ့တၢ်ရဲၣ်တၢ်ကျဲၤအပူၤတက့ၢ်. တၢ်ရဲၣ်တၢ်ကျဲၤအံၤ မၤတယၢၢ်ဝဲ တၢ်ကတဲာ်ကတီၤ ဖိဆံး ပှၤမၤလိတၢ်ဖိတဖၣ် ဒ်သိးကမၤနၢၤတၢ်လၢ ကူၣ်သ့ဂ့ၢ်ဝီတၢ်လဲၤကျဲတဖၣ်အပူၤန့ၣ်လီၤ.",
    preschoolCircleEnrollment: "တီၤဘျီကၠိဝးကဝီၤ တၢ်ဆဲးလီၤမံၤ (Preschool Circle Enrollment)",
    previous: "အပူၤကွံာ်",
    primaryLanguage: "ကျိာ်လၢစူးကါအီၤအအါကတၢၢ်",
    printedName: "မံၤလၢလံာ်မဲာ်ဖျၢၣ်အဒိၣ်",
    readingCircleDescription: "ဆဲးလီၤမံၤလၢ ပတၢ်ဖးလံာ်တၢ်ရဲၣ်တၢ်ကျဲၤအပူၤတက့ၢ်. တၢ်ရဲၣ်တၢ်ကျဲၤအံၤ တၢ်တ့တိာ်ကျဲၤအီၤ ဒ်သိးကသူၣ်ထီၣ် တၢ်သ့လံာ်သ့လဲၢ်ဂ့ၢ်ဝီ တၢ်သ့တၢ်ဘၣ်တဖၣ် ဒီး ဒ်သိးကလုၢ်ဒိၣ်ထီၣ် တၢ်အဲၣ်ဖးလံာ်အလုၢ်အလၢ်န့ၣ်လီၤ.",
    readingCircleEnrollment: "တၢ်ဖးလံာ်ဝးကဝီၤ တၢ်ဆဲးလီၤမံၤ (Reading Circle Enrollment)",
    refugee: "ပှၤဘၣ်ကီဘၣ်ခဲ",
    removeStudent: "သုးကွံာ် ပှၤကၠိဖိ",
    reviewStudentInfo: "ကွၢ်ကဒါက့ၤ ပှၤကၠိဖိအတၢ်ဂ့ၢ်တၢ်ကျိၤ",
    roleLabel: "ယမ့ၢ်...",
    saving: "တၢ်ပၢၤဃာ်တၢ်ဂ့ၢ်...",
    schoolName: "ကၠိအမံၤ",
    selectFormPrompt: "ဝံသးစူၤ ဃုထၢဘၣ် လံာ်တကွီၣ်ဒိတခါ လၢကစးထီၣ်မၤအီၤအဂီၢ်-",
    selectLanguage: "ဃုထၢ နကျိာ်",
    signature: "စုဆဲးပနီၣ်",
    signOut: "ဟးထီၣ်လၢအကီးပူၤ",
    street: "အိၣ်ဆိးလီၢ်ကျဲ",
    student: "ပှၤကၠိဖိ",
    submitAll: "တီၣ်ထီၣ်အီၤ ခဲလၢာ်",
    submitting: "တၢ်တီၣ်ထီၣ်...",
    takesMedications: "ဟဲစိာ် ကသံၣ်ကသီတဖၣ် ဖဲတၢ်ရဲၣ်တၢ်ကျဲၤအဆၢကတီၢ်ဧါ?",
    team: "ကရၢ (လၢပှၤမၤတၢ်ဖိမုာ်သးမၤကလီတဖၣ်အဂီၢ်)",
    thisIsRequired: "(တၢ်အံၤအလီၢ်အိၣ်ဝဲ)",
    volunteer: "ပှၤမၤတၢ်ဖိမုာ်သးမၤကလီ",
    volunteerInfo: "ဒုးသ့ၣ်ညါပှၤ နမၤတၢ်လၢတၢ်လီၢ်ဖဲလဲၣ်.",
    waiverAuthorizationText: "လၢတၢ်န့ၣ်အဃိ ယဟ့ၣ်စိဟ့ၣ်ကမီၤ ဆူၣ်ချ့ယါဘျါဂ့ၢ်ဝီပှၤဘၣ်မူဘၣ်ဒါ လၢ Refugee Resources, Inc. ဃုထၢပာ်အီၤတဂၤအံၤ ဒ်သိးကနဲၣ်လီၤ အဲးခ်စရ့တဖၣ် (X-rays), ဆူၣ်ချ့တၢ်သမံသမိးညီနုၢ်တဖၣ်, တၢ်မၤကွၢ်တဖၣ်, တၢ်ကူစါယါဘျါ, ဒီး တၢ်လဲၤတၢ်က့ၤတၢ်လိၣ်ဘၣ် လၢယဖိအဂီၢ်န့ၣ်လီၤ. လၢတၢ်အိၣ်သးဖဲ တၢ်တုၤအိၣ်ဆဲၤကျိးယၤ လၢဂ့ၢ်ဂီၢ်အူတၢ်အိၣ်သးတခါအပူၤ တသ့န့ၢ်အဆၢကတီၢ်, ယဟ့ၣ်စိဟ့ၣ်ကမီၤ ကသံၣ်သရၣ်လၢ Refugee Resources, Inc. ဃုထၢပာ်အီၤတဂၤအံၤ ဒ်သိးကမၤဝဲတၢ်ကူစါယါဘျါ, ပာ်ဃုာ်ဒီး တၢ်ထီၣ်တၢ်ဆါဟံၣ်, လၢယဖိအမံၤအိၣ်ဖျါလၢထးတဂၤအံၤအဂီၢ်န့ၣ်လီၤ.",
    waiverAuthorizationTitle: "တၢ်ဟ့ၣ်စိဟ့ၣ်ကမီၤတၢ်လၢ တၢ်ကူစါယါဘျါအဂီၢ်-",
    waiverBullet1: "ယနၢ်ပၢၢ်လၢ တၢ်ဒိ တၢ်ဂီၤမူဒီးတၢ်ဂီၤတဖၣ် ခဲအံၤခဲအံၤ ဖဲ Refugee Resources, Inc. လၢတၢ်အိၣ်သးအကလုာ်ကလုာ်အပူၤန့ၣ်လီၤ. လၢတၢ်န့ၣ်အဃိ ယဟ့ၣ်တၢ်ပျဲလၢ Refugee Resources, Inc. အဂီၢ် ဒ်သိးကစူးကါ ယပှၤကၠိဖိ အတၢ်ဂီၤဒီးတၢ်ဂီၤမူတဖၣ် လၢတၢ်တခူထီၣ် Refugee Resources, Inc. အတၢ်ရဲၣ်တၢ်ကျဲၤတဖၣ်အပူၤ, တပာ်ပနီၣ်ဃာ်အသးထဲတၢ်သ့ၣ်တဖၣ်အံၤဘၣ်ဆၣ်, ပာ်ဃုာ်ဒီး တၢ်စူးကါလၢအဘၣ်ထွဲဒီး တၢ်ကရၢကရိအပှာ်ယဲၤသန့တဖၣ်, ဆိရှၢၣ်မံဒံၣ်ယၢၣ် ဒီး လံာ်ဟ့ၣ်တၢ်ကစီၣ်တဖၣ် န့ၣ်လီၤ.",
    waiverBullet2: "Refugee Resources, Inc. န့ၣ်မ့ၢ်ဝဲ ပှၤခရံာ်ဖိတၢ်ကရၢကရိတဖုန့ၣ် ယနၢ်ပၢၢ်လီၤ ဒီး ယဟ့ၣ်တၢ်ပျဲဆူ Refugee Resources ဒ်သိးကသိၣ်လိယဖိလၢ လံာ်စီဆှံဂ့ၢ်ဝီတၢ်ဃဲၤပူတဖၣ်န့ၣ်လီၤ.",
    waiverBullet3: "ယပှၤကၠိဖိ(တဖၣ်) မ့ၢ်မၤကမၣ်ဘၣ် မ့တမ့ၢ် မ့ၢ်ဂုာ်ကျဲးစၢးလၢကမၤဝဲ တၢ်မၤလၢအတကြၢးတဘၣ် မ့တမ့ၢ် လုၢ်လၢ်လၢတၢ်တူၢ်လာ်အီၤတသ့ တမံၤတမၠိ ဖဲ Refugee Resources, Inc. န့ၣ်, ယဟ့ၣ်တၢ်ပျဲဆူ Refugee Resources, Inc ပှၤမၤတၢ်ဖိတဖၣ် ဒ်သိးကသူဝဲ တၢ်ဟံးဂ့ၢ်ဝီစံၣ်ညီၣ်တၢ် လၢအလီၢ်ကအိၣ်ဝဲနီၢ်နီၢ်တဖၣ်န့ၣ်လီၤ. တပာ်ပနီၣ်ဃာ်အသးထဲတၢ်သ့ၣ်တဖၣ်အံၤဘၣ်ဆၣ်, တၢ်ပိာ်ထွဲဟံးဂ့ၢ်ဝီတဖၣ်န့ၣ် ပာ်ဃုာ်ဒီး တၢ်တဲသကိးတၢ်ဒီး တၢ်မၤလီၢ်သရၣ်/ တၢ်ရဲၣ်တၢ်ကျဲၤပှၤနဲၣ်တၢ်, တၢ်ဒုးသ့ၣ်ညါမိၢ်ပၢ်တဖၣ် ဒီး တၢ်ဒုးဟးထီၣ် ပှၤကၠိဖိအံၤ လၢတၢ်ရဲၣ်တၢ်ကျဲၤအံၤအပူၤ လၢပှၤကၠိဖိအဂၤတဖၣ် အတၢ်ပူၤဖျဲးဘံၣ်ဘၢ ဒီး တၢ်အိၣ်မုာ်အိၣ်ပၢၤအဂီၢ် န့ၣ်လီၤ (လၢတၢ်အိၣ်သးအံၤအပူၤ သရၣ်ဟ့ၣ်ကူၣ်တၢ်တဖၣ် ကမၢမိၢ်ပၢ်တဖၣ် က့ၤကိးက့ၤအဖိအံၤဆူအဟံၣ်န့ၣ်လီၤ.)",
    waiverBullet4: "ခီဖျိဆဲးလီၤစုဆဲးပနီၣ်လၢလံာ်တီလံာ်မီအံၤအပူၤ, ယအုၣ်သးလၢ ယဟ့ၣ်တၢ်ပျဲလၢယဖိအဂီၢ် ဒ်သိးကပာ်ဃုာ်လၢ Reading Circle တၢ်ရဲၣ်တၢ်ကျဲၤအပူၤ ဒီး တၢ်ရဲၣ်တၢ်ကျဲၤ မ့တမ့ၢ် တၢ်ဟူးတၢ်ဂဲၤလၢ Refugee Resources, Inc. ဆီၣ်ထွဲအီၤတဖၣ်အပူၤန့ၣ်လီၤ. ယနၢ်ပၢၢ်လၢ ယကဘၣ်အၢၣ်လီၤလူၤပိာ်မၤထွဲ တၢ်သိၣ်တၢ်ဘျၢလၢတၢ်ပာ်လီၤအီၤဖဲအံၤတဖၣ်န့ၣ်လီၤ.",
    waiverContent1: "ဖဲ REFUGEE RESOURCES, INC ပမၤကယဲၢ်တၢ်လၢပမၤအီၤသ့တဖၣ် ဒ်သိးကမၤလီၤတံၢ်...",
    waiverContent2: "အလီၢ်အိၣ်သပှၢ်ကတၢၢ်လၢ ပှၤကဘၣ်မၤပှဲၤ လံာ်တကွီၣ်ဒိအံၤ...",
    waiverFormTitle: "တၢ်ဟံးမူဟံးဒါအလံာ်တကွီၣ်ဒိ 2025-2026",
    waiverParagraph1: "ဖဲ REFUGEE RESOURCES, INC. ပမၤကယဲၢ်တၢ်လၢပမၤအီၤသ့တဖၣ် ဒ်သိးကမၤလီၤတံၢ်လၢ နဖိကဒိးန့ၢ်ဘၣ် တၢ်မၤလိအတၢ်လဲၤခီဖျိ, တကးဘၣ် တၢ်လဲၤခီဖျိလၢအလီၤသူၣ်ဖှံသးညီန့ၣ်လီၤ",
    waiverParagraph2: "အလီၢ်အိၣ်သပှၢ်ကတၢၢ်လၢ ပှၤကၠိဖိ(တဖၣ်) အမိၢ်ပၢ်(တဖၣ်) မ့တမ့ၢ် သဲစးဖိး ပှၤကွၢ်ထွဲတၢ်(တဖၣ်) ကမၤပှဲၤ လံာ်တကွီၣ်ဒိအံၤ, ဆဲးလီၤစုဆဲးပနီၣ်ဒီး ကွဲးလီၤမုၢ်နံၤမုၢ်သီလၢအပူၤ ဒီးဆှၢက့ၤအီၤန့ၣ်လီၤ.",
    waiverParagraph3: "ပမ့ၢ်တဒိးန့ၢ်ဘၣ် လံာ်တကွီၣ်ဒိအံၤန့ၣ် တမ့ၢ်တၢ်ကပျဲထီၣ်နဖိလၢ တၢ်ရဲၣ်တၢ်ကျဲၤတဖၣ် နီတမံၤဘၣ်.",
    waiverParagraph4: "ခီဖျိ မၤလၢမၤပှဲၤ, ဆဲးလီၤစုဆဲးပနီၣ်လၢ လံာ်တီလံာ်မီအံၤ, လၢတၢ်သ့ၣ်ညါဒီးတၢ်သးအိၣ်အပူၤ ယပျဲပူၤ REFUGEE RESOURCES, INC အပှၤမၤတၢ်ဖိတဖၣ်, အကမံးတံာ်မိၢ်ပှၢ်, ပှၤမၤတၢ်ဖိမုာ်သးမၤကလီတဖၣ် (သရၣ်ဟ့ၣ်ကူၣ်တၢ်တဖၣ်) ဒီး ကယဲၢ်ပှၤလၢအမၤတၢ်လၢ  REFUGEE RESOURCES, INC အဂီၢ် မ့တမ့ၢ် အခၢၣ်စးတဖၣ် လၢတၢ်ဘၣ်ဟံးမူဟံးဒါတမံၤလၢ်လၢ်အဂီၢ်, လၢနီၢ်ကစၢ်တၢ်ဘၣ်ဒိဘၣ်ထံး, မ့တမ့ၢ် တၢ်စုလီၢ်ခီၣ်ခိၣ် တၢ်ဘၣ်ဒိဘၣ်ထံးတဖၣ် လၢအဟဲကဲထီၣ်အသးလၢ တၢ်ပာ်ဃုာ်လၢ REFUGEE RESOURCES, INC အတၢ်ရဲၣ်တၢ်ကျဲၤတမံၤတမၠိအပူၤအဂီၢ် န့ၣ်လီၤ.",
    waiverProgramTitle: "Reading Circle & Preschool Circle",
    waiverSubtitle: "တၢ်မၤဆူၣ်ထီၣ်ဂံၢ်ဘါ ခီဖျိ တၢ်သ့ဖးသ့ကွဲးလံာ်လဲၢ်",
    waiverTitle: "REFUGEE RESOURCES",
    welcome: "ပတူၢ်လိာ်မုာ်ဘၣ်နၤလီၤ! တဲပၠးပှၤနဂ့ၢ်နကျိၤ.",
    welcomeForm: "ပတူၢ်လိာ်မုာ်ဘၣ်နၤလီၤ",
    yes: "မ့ၢ်",
    zip: "စံး(ပ) ပနီၣ်တဒၢ",
  },
  sw: { // Swahili
    acknowledgeLabel: "Ninakubali",
    acknowledgment: "Unapoamua kuendelea, unakubali kwamba taarifa zote zinazotolewa ni sahihi kwa kadiri unavyojua na zinaweza kutumika kutoa huduma zinazofaa.",
    addAnotherStudent: "Ongeza Mwanafunzi Mwingine",
    additionalComments: "Maoni ya Ziada",
    additionalFormsDescription: "Chaguzi za ziada za uandikishaji zitapatikana hapa.",
    allergies: "Mizio (Tia alama kwenye yote yanayotumika):",
    allergiesEggs: "Mayai",
    allergiesEnvironmental: "Mizio ya mazingira",
    allergiesFood: "Mizio ya chakula",
    allergiesInsectStings: "Kuumwa na wadudu",
    allergiesLatex: "Mpira",
    allergiesMedical: "Mizio ya Dawa",
    allergiesMilk: "Maziwa",
    allergiesNone: "Hakuna",
    allergiesOtherSpecified: "Nyingine (tafadhali taja)",
    allergiesPeanuts: "Karanga",
    allergiesPenicillin: "Penicillin",
    allergiesPoisonIvy: "Poison Ivy",
    allergiesPollen: "Chavua",
    allergiesSesame: "Ufuta",
    allergiesShellfish: "Samakigamba",
    allergiesSoy: "Soya",
    allergiesTreeNuts: "Karanga za miti",
    allergiesWheat: "Ngano",
    apartment: "Ghorofa",
    appTitle: "Rasilimali za Wakimbizi",
    aptName: "Jina la Ghorofa",
    aptNumber: "Nambari ya Ghorofa",
    arrival: "Tarehe ya Kuwasili",
    back: "Nyuma",
    background: "Mandharinyuma",
    backgroundStep: "Mandharinyuma",
    beginForm: "Anza Fomu",
    cancel: "Katisha",
    chooseLanguage: "Tafadhali chagua lugha unayopendelea:",
    city: "Mji",
    complete: "Kamilisha",
    completeProfile: "Kamilisha Wasifu Wako",
    continueToReview: "Endelea Kukagua",
    continueToWaiver: "Endelea Kusamehewa",
    currentGrade: "Gredi ya Sasa",
    date: "Tarehe",
    dateOfBirth: "Tarehe ya Kuzaliwa",
    dwelling: "Aina ya Makao",
    edit: "Hariri",
    editProfile: "Hariri Wasifu Wako",
    enrollmentAcknowledgment: "Ninathibitisha kuwa nina mamlaka ya kuandikisha wanafunzi hawa.",
    enrollmentAcknowledgmentError: "Tafadhali ongeza angalau mwanafunzi mmoja na uthibitishe kukiri mamlaka.",
    enrollmentError: "Kulikuwa na shida kuwasilisha uandikishaji.",
    enrollmentSuccess: "Uandikishaji uliowasilishwa umefaulu!",
    female: "Kike",
    firstName: "Jina la Kwanza",
    footerText: "Kubadilisha Maisha, Mtoto baada ya Mwingine",
    gender: "Jinsia",
    guardian: "Mlezi",
    healthConditions: "Masharti ya Afya (Tia alama kwenye yote yanayotumika):",
    healthConditionsAdhd: "ADHD",
    healthConditionsAnxiety: "Wasiwasi",
    healthConditionsAsd: "Ugonjwa wa Autism Spectrum",
    healthConditionsAsthma: "Pumu",
    healthConditionsBleedingClottingDisorder: "Ugonjwa wa Kuganda kwa Damu",
    healthConditionsConvulsions: "Degedege",
    healthConditionsCysticFibrosis: "Cystic Fibrosis",
    healthConditionsDepression: "Unyogovu",
    healthConditionsDiabetes: "Kisukari",
    healthConditionsHearingImpairment: "Ulemavu wa Kusikia",
    healthConditionsHeartDisease: "Ugonjwa wa moyo",
    healthConditionsMentalHealth: "Afya ya akili",
    healthConditionsNeurological: "Neurological",
    healthConditionsNone: "Hakuna",
    healthConditionsOther: "Nyingine",
    healthConditionsOtherSpecified: "Nyingine (tafadhali taja)",
    healthConditionsRespiratory: "Kupumua",
    healthConditionsSeizures: "Kifafa",
    healthConditionsSensory: "Hisia",
    healthConditionsVisionImpairment: "Uharibifu wa kuona",
    house: "Nyumba",
    housing: "Unaishi wapi?",
    housingInfo: "Taarifa za Makazi",
    housingInfoStep: "Taarifa za Makazi",
    iAcknowledge: "Ninakubali kwamba taarifa zote zinazotolewa ni sahihi",
    initialAgreement: "Nimesoma na kukubaliana na masharti hapo juu (Hapo awali)",
    initialIfYouAgree: "Awali ikiwa unakubali:",
    journey: "Tuambie kuhusu safari yako",
    language: "Lugha",
    languagePref: "Mapendeleo ya Lugha",
    languageStep: "Lugha",
    lastName: "Jina la Mwisho",
    liabilityWaiver: "Mkataba wa Kuondolewa kwa Dhima",
    male: "Kiume",
    moreFormsComing: "Fomu Zaidi Zinakuja hivi Karibuni",
    next: "Ijayo",
    no: "La",
    office: "Mahali pa Ofisi (kwa watu wa kujitolea)",
    origin: "Nchi ya Asili",
    parent: "Mzazi",
    personalInfo: "Taarifa za Kibinafsi",
    personalInfoStep: "Taarifa za Kibinafsi",
    phone: "Nambari ya Simu",
    physicalRestrictions: "Vizuizi vyovyote vya kimwili au matatizo ya afya?",
    physicalRestrictionsQuestion: "Je, mwanafunzi ana vikwazo vyovyote vya kimwili au matatizo ya afya yanayoweza kutokea?",
    preferredLang: "Lugha Inayopendekezwa",
    preschoolCircleDescription: "Andikisha watoto katika mpango wetu wa elimu ya mapema unaolenga kuandaa wanafunzi wachanga kufanikiwa katika masomo yao.",
    preschoolCircleEnrollment: "Uandikishaji wa Mduara wa Shule ya Mapema",
    previous: "Iliyotangulia",
    primaryLanguage: "Lugha ya Msingi",
    printedName: "Jina Lililochapishwa",
    readingCircleDescription: "Andikisha watoto katika mpango wetu wa kusoma ulioundwa ili kujenga ujuzi wa kusoma na kuandika na kukuza upendo wa kusoma.",
    readingCircleEnrollment: "Uandikishaji wa Mduara wa Kusoma",
    refugee: "Wakimbizi",
    removeStudent: "Ondoa Mwanafunzi",
    reviewStudentInfo: "Kagua Maelezo ya Wanafunzi",
    roleLabel: "Mimi ni...",
    saving: "Inahifadhi...",
    schoolName: "Jina la Shule",
    selectFormPrompt: "Tafadhali chagua fomu ili uanze:",
    selectLanguage: "Chagua lugha yako",
    signature: "Saini",
    signOut: "Ondoka",
    street: "Anwani ya Mtaa",
    student: "Mwanafunzi",
    submitAll: "Wasilisha Zote",
    submitting: "Inawasilisha...",
    takesMedications: "Je, Unatumia Dawa Wakati Mpango Unaendelea?",
    team: "Timu (kwa watu wa kujitolea)",
    thisIsRequired: "(Hii inahitajika)",
    volunteer: "Kujitolea",
    volunteerInfo: "Tuambie unahudumu wapi.",
    waiverAuthorizationText: "Kwa hivyo ninaidhinisha wafanyakazi wa matibabu waliochaguliwa na Refugee Resources, Inc. kuagiza X-rays, utaratibu, vipimo, matibabu, na usafiri muhimu kwa mtoto wangu. Katika tukio ambalo siwezi kufikiwa kwa dharura, ninaidhinisha daktari aliyechaguliwa na Refugee Resources, Inc. apate na kusimamia matibabu, ikiwa ni pamoja na kulazwa hospitalini, kwa mtoto wangu kama ilivyotajwa hapo juu.",
    waiverAuthorizationTitle: "Uidhinishaji wa Matibabu:",
    waiverBullet1: "Ninaelewa kuwa video na picha hupigwa mara kwa mara wakati wa hafla anuwai katika Rasilimali za Wakimbizi, Inc. Kwa hivyo ninatoa ruhusa yangu kwa Rasilimali za Wakimbizi kutumia picha na video za mwanafunzi wangu kwa kukuza Refugee Resources, Inc. ikiwa ni pamoja na, lakini sio tu kutumia katika tovuti za shirika, mitandao ya kijamii na vipeperushi.",
    waiverBullet2: "Ninaelewa kuwa Refugee Resources, Inc. ni shirika la Kikristo na ninatoa ruhusa kwa Rasilimali za Wakimbizi kufundisha Hadithi za Biblia kwa mwanafunzi wangu.",
    waiverBullet3: "Ninatoa ruhusa kwa wafanyakazi wa Refugee Resources, Inc kutekeleza hatua za kinidhamu zinazokubalika ambazo zinaweza kuhitajika ikiwa mwanafunzi wangu atafanya (s) au kujaribu (s) kuwa na utovu wa nidhamu au tabia isiyokubalika katika Refugee Resources, Inc. Matokeo ni pamoja na lakini si tu kukatizwa kwa sababu ya muda, majadiliano na mwalimu wa Eneo/Mwelekezi wa Mpango, kuwajulisha wazazi na kuomba mwanafunzi aondoke mpangoni kwa sababu ya usalama na ustawi wa wanafunzi wengine kwa ujumla (hapa, washauriwataomba wazazi kusindikiza mwanafunzi kurudi nyumbani kwao.)",
    waiverBullet4: "Ninapotia saini hati hii, ninathibitisha kwamba ninatoa ruhusa kwa mtoto wangu kushiriki katika mpango wa Reading Circle na mipango au shughuli zozote zinazofadhiliwa na Refugee Resources, Inc. Ninaelewa kuwa masharti hapa ni ya kimkataba.",
    waiverContent1: "Katika REFUGEE RESOURCES, INC tunafanya kila tuwezalo kuhakikisha...",
    waiverContent2: "Ni lazima fomu hii ijazwe...",
    waiverFormTitle: "Fomu ya Dhima 2025-2026",
    waiverParagraph1: "Katika REFUGEE RESOURCES, INC. tunafanya kila tuwezalo kuhakikisha kuwa mtoto wako hana hajifunzi tu bali pia anafurahia!",
    waiverParagraph2: "Ni lazima fomu hii ijazwe, isainiwe na tarehe na wazazi au walezi wa kisheria wa mwanafunzi na kurudishwa.",
    waiverParagraph3: "Mwanafunzi wako hataruhusiwa kuhudhuria hafla zozote isipokuwa wakati tutakapopokea fomu hii.",
    waiverParagraph4: "NINAPOKUBALI KUTEKELEZA HATI HII, NINAWAACHILIA KWA KUJUA NA KWA HIARI REFUGEE RESOURCES, INC, WAFANYAKAZI, BODI, WANAOJITOLEA (WASHAURI) NA WENGINE WOTE WANAOFANYA KAZI KWA NIABA YA REFUGEE RESOURCES, INC. KUTOKA KWA DHIMA YOYOTE, KWA JERAHA LA KIBINAFSI, AU MAJERAHA YA MALI YANAYOSABABISHWA NA, AU YANAYOTOKANA NA KUSHIRIKI KATIKA KUSHIRIKI KWENYE TUKIO LILILOPANGWA NA REFUGEE RESOURCES, INC.",
    waiverProgramTitle: "Reading Circle & Preschool Circle",
    waiverSubtitle: "Kuwezesha Kupitia Kusoma na Kuandika",
    waiverTitle: "RASILIMALI ZA WAKIMBIZI",
    welcome: "Karibu! Tuambie kuhusu wewe mwenyewe.",
    welcomeForm: "Karibu",
    yes: "Ndiyo",
    zip: "Msimbo wa Zip",
  },
};

export default translations;
